import { render, staticRenderFns } from "./SchoolLeaveApplicationTableControl.vue?vue&type=template&id=7b5d8725&scoped=true&"
import script from "./SchoolLeaveApplicationTableControl.vue?vue&type=script&lang=js&"
export * from "./SchoolLeaveApplicationTableControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5d8725",
  null
  
)

export default component.exports